// Module
var code = "<!-- ko foreach: _cellEditors --> <!-- ko template: {html: _template} --> <!-- /ko --> <!-- /ko --> ";
// Exports
export default code;